export default "__VITE_ASSET__E8P28fjA__"